import { render, staticRenderFns } from "./ContestEntryComplete.vue?vue&type=template&id=863e1074&scoped=true"
import script from "./ContestEntryComplete.vue?vue&type=script&lang=ts"
export * from "./ContestEntryComplete.vue?vue&type=script&lang=ts"
import style0 from "./ContestEntryComplete.vue?vue&type=style&index=0&id=863e1074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863e1074",
  null
  
)

export default component.exports